import * as React from "react";
import { Redirect, Route, Switch } from "wouter";
import { Habits } from "./daily/Habits";
import { Planner } from "./daily/Planner";
import { Categories } from "./finances/Categories";
import { Transactions } from "./finances/Transactions";
import { Rules } from "./finances/Rules";
import { LinkAccount } from "./finances/LinkAccount";
import { Goals } from "./goals/Goals";
import { GoalPage } from "./goals/GoalPage";
import { Backlog } from "./daily/Backlog";
import { Styleguide } from "./Styleguide";
import { Calendar } from "./daily/Calendar";
import { getLocalDate } from "src/database/utils/localDate";
import { createTaskFormContext, TaskFormProvider } from "./daily/TaskForm/taskFormContext";
import { useSync } from "./useSync";

export function Router() {
  useSync();
  const taskFormContext = createTaskFormContext();
  return (
    <TaskFormProvider value={taskFormContext}>
      <Switch>
        <Route path="/tasks/:date" component={Planner} />
        <Route path="/calendar/:date" component={Calendar} />
        <Route path="/habits" component={Habits} />
        <Route path="/goals/:id" component={GoalPage} />
        <Route path="/goals" component={Goals} />
        <Route path="/backlog" component={Backlog} />
        <Route path="/finances/transactions" component={Transactions} />
        <Route path="/finances/link" component={LinkAccount} />
        <Route path="/finances/rules" component={Rules} />
        <Route path="/finances/categories" component={Categories} />
        <Route path="/styleguide" component={Styleguide} />
        <Route>
          <Redirect to={`/tasks/${getLocalDate(new Date())}`} replace />
        </Route>
      </Switch>
    </TaskFormProvider>
  );
}
